__webpack_require__.p = "/ai-medical/";